import { render, staticRenderFns } from "./BookingHotelView.vue?vue&type=template&id=b5e22760&scoped=true&"
import script from "./BookingHotelView.vue?vue&type=script&lang=js&"
export * from "./BookingHotelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e22760",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5e22760')) {
      api.createRecord('b5e22760', component.options)
    } else {
      api.reload('b5e22760', component.options)
    }
    module.hot.accept("./BookingHotelView.vue?vue&type=template&id=b5e22760&scoped=true&", function () {
      api.rerender('b5e22760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/BookingHotelView.vue"
export default component.exports